import React from "react";
import { Icons } from "../../components/common/Icons";
import { useEmployeeData } from "../../context/EmployeeContext";
import api from "../../services/api";
import "../../assets/styles/Employee/EmpPoliciesPage.css";

function EmpPoliciesPage() {
  const { empPolicies } = useEmployeeData();

  const handleDownload = async (policy) => {
    try {
      const res = await api.downloadPolicy(policy.id);
      const filename = res?.name || policy.name || policy.title || 'policy';
      if (res?.url) {
        await api.downloadFile(res.url, filename);
      } else if (res?.content) {
        const blob = new Blob([res.content], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename.endsWith('.txt') ? filename : `${filename}.txt`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
    } catch (e) {
      alert('Download failed: ' + e.message);
    }
  };

  return (
    <div className="card animate-in">
      <div className="card-header"><div className="card-title">Policy Documents</div><div className="card-subtitle">{empPolicies.length} policies</div></div>
      <div className="card-body">{empPolicies.length === 0 ?
        <div className="emppoliciespage-inline-1">No policies available</div> :
        empPolicies.map((p, i) =>
          <div className="list-item" key={i}>
            <div className="list-icon"><Icons.BookOpen /></div>
            <div className="list-content"><div className="list-title">{p.name || p.title}</div><div className="list-sub">{p.category || 'General'} | Updated {p.updated ? new Date(p.updated).toLocaleDateString('en-IN') : '-'}</div></div>
            <div className="list-action emppoliciespage-inline-2" onClick={() => handleDownload(p)}><Icons.Download /> Download</div>
          </div>
        )}</div>
    </div>
  );
}

export default EmpPoliciesPage;
